import { render, staticRenderFns } from "./dictionaryWords.vue?vue&type=template&id=24cf8736&scoped=true"
import script from "./dictionaryWords.vue?vue&type=script&lang=js"
export * from "./dictionaryWords.vue?vue&type=script&lang=js"
import style0 from "./dictionaryWords.vue?vue&type=style&index=0&id=24cf8736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cf8736",
  null
  
)

export default component.exports